exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.name-box[data-v-201d77b1]{margin-bottom:10px}}.product-name[data-v-201d77b1]{font-size:28px;font-weight:500;position:relative}.product-name .wishlist-button[data-v-201d77b1]{position:absolute;right:0;top:-7px}@media (max-width: 767px){.product-name[data-v-201d77b1]{font-size:26px}}\n", ""]);

// exports
